import React from "react";
import axios from "axios";
import {
  BASE_URL,
  DELIVERY,
  ORDERINFO,
  ORDERS,
  WAREHOUSE,
  LOGS,
  HEADERS,
  DRIVERS,
  REGIONS,
  CURRENTUSER,
} from "../../common/api";
import Error from "../../assets/js/Error";
import Pagination from "../../common/pagination";

export default class SingleOrder extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: this.props.match.params.id,
      type: this.props.match.params.orderType,
      name: "",
      phone: "",
      region: "",
      district: "",
      address: "",
      comment: "",
      orderStatus: "",
      price: "",
      status: "",
      expected_delivery_date: "",
      warehouse: "",
      deliver: "",
      deliver_name: "",
      employee: "",
      warehouse_name: "",
      log: [],
      items: [],
      filteredItems: [],
      methods: [],
      warehouses: [],
      drivers: [],
      isWarehouseSelected: false,
      resStatus: 0,
      isRegion: false,
      region_id: 0,
      in_warehouse: "",
      barcodes: [],
      barcode: "",
      currentPage: 1,
      totalPages: 1,
      status_payment: "",
    };
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handlePageChange(pageNumber) {
    this.setState({
      currentPage: pageNumber,
    });
    this.getData(pageNumber);
  }
  handleWarehouseChange = (event, item) => {
    const { value } = event.target;
    const product = this.state.items.find((product) => product.id === item.id);
    const updatedProduct = JSON.parse(JSON.stringify(product));
    updatedProduct.warehouse_in = value;
    updatedProduct.product.units = updatedProduct.product.units.filter(
      (el) => el.warehouse == value
    );
    const updatedProducts = this.state.filteredItems.map((data) =>
      data.id === updatedProduct.id ? updatedProduct : data
    );
    this.setState({ filteredItems: updatedProducts });
  };

  handleBarcodeChange = (event, item) => {
    const { value } = event.target;
    const warehouse = item.product.units.find((el) => el.barcode === value);

    const updatedBarcode = { 
      ...item, 
      barcode: value,
      warehouse_in: warehouse["warehouse"],
      warehouse_name: warehouse["warehouse_name_uz"], 
    };
    const updatedBarcodes = this.state.filteredItems.map((data) =>
      data.id === updatedBarcode.id ? updatedBarcode : data
    );
    this.setState({ filteredItems: updatedBarcodes });
  };

  confirmOrder = (id) => {
    const { employee, type } = this.state;
    let data = {};
    let logData = {};
    if (type === "1") {
      this.setState({ orderStatus: 1 });
      data["order_status"] = 1;
      logData["action"] = "Заказ принят";
      logData["manager"] = employee;
      logData["order"] = id;
    } else if (type === "2") {
      this.setState({ orderStatus: 1 });
      data["order_status"] = 1;
      data["delivery_status"] = "Delivery attached";
      logData["action"] = "Заказ изменен";
      logData["manager"] = employee;
      logData["order"] = id;
    }
    axios.put(BASE_URL + ORDERINFO + id + "/", data, HEADERS);
    axios.post(BASE_URL + LOGS + id + "/", logData, HEADERS).then((res) => {
      const data = res.data;
      data["date"] =
        new Date(data["date"]).toLocaleDateString("ru-RU") +
        "  " +
        new Date(data["date"]).toLocaleTimeString("ru-RU").slice(0, 5);
      this.setState({ log: [...this.state.log, data] });
    });
  };

  rejectOrder = (id) => {
    let data = {
      order_status: 5,
    };
    axios
      .put(BASE_URL + ORDERINFO + id + "/", data, HEADERS)
      .then(this.setState({ orderStatus: 5 }));
  };

  confirmWarehouse = () => {
    const { id, employee, warehouse } = this.state;
    let logData = {
      action: "Заказ изменен",
      manager: employee,
      order: id,
    };
    let orderData = {
      warehouse: warehouse,
    };
    axios.patch(BASE_URL + ORDERINFO + id + "/", orderData, HEADERS).then(
      axios.post(BASE_URL + LOGS + id + "/", logData, HEADERS).then((res) => {
        const data = res.data;
        data["date"] =
          new Date(data["date"]).toLocaleDateString("ru-RU") +
          "  " +
          new Date(data["date"]).toLocaleTimeString("ru-RU").slice(0, 5);
        this.setState({
          log: [...this.state.log, data],
          isWarehouseSelected: true,
        });
      })
    );
  };

  async componentDidMount() {
    const { id } = this.state;
    if (id === "add") {
      return;
    } else {
      await axios.get(BASE_URL + ORDERINFO + id, HEADERS).then((res) => {
        const order = res.data;
        const resStatus = res.status;
        const date = new Date(order.expected_delivery_date)
          .toISOString()
          .split("T")[0];

        this.setState({
          name: order.name,
          phone: order.phone,
          region: order.region_name,
          region_id: order.region,
          district: order.district_name,
          address: order.address,
          comment: order.comment,
          orderStatus: order.order_status,
          items: order.order_items,
          filteredItems: order.order_items,
          price: order.price,
          status: order.status,
          warehouse: order.warehouse,
          warehouse_name: order.warehouse_name,
          expected_delivery_date: date,
          deliver: order.deliver,
          deliver_name: order.deliver_name,
          resStatus: resStatus,
          status_payment: order.status_payment,
        });
      });
      await axios.get(BASE_URL + CURRENTUSER, HEADERS).then((res) => {
        const regions = res.data.regions;
        console.log(res.data);
        const isInRegion = regions.some((el) => el === this.state.region_id);
        this.setState({ isInRegion });
      });
      await axios.get(BASE_URL + DELIVERY, HEADERS).then((res) => {
        const methods = res.data;
        this.setState({ methods: methods, resStatus: res.status });
      });
      await axios.get(BASE_URL + WAREHOUSE, HEADERS).then((res) => {
        this.setState({ warehouses: res.data, resStatus: res.status }, () => {
          console.log(this.state.warehouses);
        });
      });
      await axios
        .get(BASE_URL + "users/user/", HEADERS)
        .then((res) => this.setState({ employee: res.data.id }));
      await axios.get(BASE_URL + LOGS + id, HEADERS).then((res) => {
        const log = res.data;
        log.map(
          (el) =>
            (el.date =
              new Date(el.date).toLocaleDateString("ru-RU") +
              "  " +
              new Date(el.date).toLocaleTimeString("ru-RU").slice(0, 5))
        );
        this.setState({ log: log });
      });
      await axios
        .get(BASE_URL + DRIVERS, HEADERS)
        .then((res) =>
          this.setState({ drivers: res.data, resStatus: res.status })
        );
    }
  }

  render() {
    const {
      name,
      phone,
      region,
      district,
      address,
      comment,
      filteredItems,
      items,
      id,
      price,
      orderStatus,
      status,
      warehouse,
      methods,
      drivers,
      expected_delivery_date,
      log,
      warehouses,
      isWarehouseSelected,
      type,
      warehouse_name,
      barcode,
      resStatus,
      isInRegion,
      in_warehouse,
      barcodes,
      currentPage,
      totalPages,
      deliver,
      deliver_name,
    } = this.state;
    return (
      <>
        {resStatus === 200 ?  (
          <div className="single-order">
            <div className="">
              {orderStatus !== 5 && (
                <button
                  className={`btn btn-info ${
                    isWarehouseSelected || deliver ? "" : "disabled"
                  }`}
                  onClick={() => this.confirmOrder(id)}
                >
                  Подтверждение заказа
                </button>
              )}
              <button
                className="btn btn-danger mx-2"
                disabled={(orderStatus === 0 || orderStatus === 7) ? false : true}
                onClick={() => this.rejectOrder(id)}
              >
                Отмена заказа
              </button>
            </div>
            <div className="main">
              <div className="customer-info">
                <div className="status">
                  <span>№ {id}</span>
                  <span className="badge badge-success">{status}</span>
                </div>
                <hr />
                <div className="info">
                  <form>
                    <div className="form-group">
                      <label htmlFor="name">Ф.И.О</label>
                      {(orderStatus === 0 || orderStatus === 7) ? (
                        <input
                          type="text"
                          className="form-control"
                          name="name"
                          value={name || ""}
                          id="name"
                          aria-describedby="emailHelp"
                          onChange={this.handleChange}
                        />
                      ) : (
                        <h6>{name}</h6>
                      )}
                    </div>
                  </form>
                  <form>
                    <div className="form-group">
                      <label htmlFor="phone">Номер телефона</label>
                      {orderStatus === 0 ? (
                        <input
                          type="text"
                          className="form-control"
                          name="phone"
                          value={phone || ""}
                          id="phone"
                          onChange={this.handleChange}
                        />
                      ) : (
                        <h6>{phone}</h6>
                      )}
                    </div>
                  </form>
                  <form>
                    <div className="form-group">
                      <label htmlFor="region">Регион</label>
                      {(orderStatus === 0 || orderStatus === 7) ? (
                        <input
                          type="text"
                          className="form-control"
                          name="region"
                          value={region || ""}
                          disabled
                          id="region"
                          aria-describedby="emailHelp"
                          onChange={this.handleChange}
                        />
                      ) : (
                        <h6>{region}</h6>
                      )}
                    </div>
                  </form>
                  <form>
                    <div className="form-group">
                      <label htmlFor="district">Район</label>
                      {(orderStatus === 0 || orderStatus === 7) ? (
                        <input
                          type="text"
                          className="form-control"
                          name="district"
                          value={district || ""}
                          disabled
                          id="district"
                          aria-describedby="emailHelp"
                          onChange={this.handleChange}
                        />
                      ) : (
                        <h6>{district}</h6>
                      )}
                    </div>
                  </form>
                  <form>
                    <div className="form-group">
                      <label htmlFor="address">Адрес</label>
                      {(orderStatus === 0 || orderStatus === 7) ? (
                        <input
                          type="text"
                          className="form-control"
                          name="address"
                          value={address || ""}
                          id="address"
                          aria-describedby="emailHelp"
                          onChange={this.handleChange}
                        />
                      ) : (
                        <h6>{address}</h6>
                      )}
                    </div>
                  </form>
                  <form>
                    <div className="form-group">
                      <label htmlFor="comment">Комментарий клиента</label>
                      {(orderStatus === 0 || orderStatus === 7)? (
                        <input
                          type="text"
                          className="form-control"
                          name="comment"
                          value={comment || ""}
                          id="comment"
                          aria-describedby="emailHelp"
                          onChange={this.handleChange}
                        />
                      ) : (
                        <h6>{comment}</h6>
                      )}
                    </div>
                  </form>
                </div>
                <hr />
                <div className="info delivery-info">
                  <form>
                    <div className="form-group">
                      <label htmlFor="driver">Доставщик</label>
                      <select
                        className="form-control"
                        name="deliver"
                        id="deliver"
                        onChange={this.handleChange}
                        value={deliver || ""}
                      >
                        {drivers.map((driver, index) => (
                          <option value={driver.id} key={index}>
                            {driver.first_name + " " + driver.last_name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </form>
                  <form>
                    <div className="form-group">
                      <label htmlFor="textInput">Способ доставки</label>
                      <select
                        className="form-control"
                        name="titleUz"
                        id="textInput"
                        onChange={this.handleChange}
                      >
                        {methods.map((method) => (
                          <option value={method.id} key={method.id}>
                            {method.nameUz}
                          </option>
                        ))}
                      </select>
                    </div>
                  </form>
                  <form>
                    <div className="form-group">
                      <label htmlFor="delivery_date">
                      Дата доставки
                      </label>
                      <input
                        type="date"
                        className="form-control"
                        name="expected_delivery_date"
                        defaultValue={expected_delivery_date}
                        id="delivery_date"
                      />
                    </div>
                  </form>

                  <div className="delivery-dates">
                    <div>
                      <label>Время начала доставки</label>
                      <span>---</span>
                    </div>
                    <div>
                      <label>Время окончания доставки</label>
                      <span>---</span>
                    </div>
                    <div>
                      <label>Kuryer manzilga kirish</label>
                      <span>---</span>
                    </div>
                    <div>
                      <label>Kuryer manzilga chiqishi</label>
                      <span>---</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="order-info">
                <div className="order">
                  <div className="warehouse">
                    {type === "1" && (orderStatus === 0 || orderStatus === 7) ? (
                      <>
                        <div>
                          <h6>Собирающий склад</h6>
                          <select
                            className="form-control"
                            aria-label="Default select example"
                            onChange={this.handleChange}
                            name="warehouse"
                            value={warehouse}
                          >
                            <option hidden>Выберите:</option>
                            {warehouses.map((item) => (
                              <option value={item.id} key={item.id}>
                                {item.name_uz}
                              </option>
                            ))}
                          </select>
                        </div>
                        <button
                          className={`btn btn-primary ${
                            warehouse ? "" : "disabled"
                          }`}
                          onClick={() => this.confirmWarehouse()}
                        >
                          Подтверждение склада
                        </button>
                      </>
                    ) : (
                      <>
                        <h6>Собирающий склад: {warehouse_name}</h6>
                      </>
                    )}
                  </div>

                  <div className="order-list">
                    <label>Основные товары</label>
                    <table className="table">
                      <thead>
                        <tr>
                          <th>Артикул</th>
                          <th>Количество</th>
                          <th>Дни доставки</th>
                          <th>Склад</th>
                          <th>Barcode</th>
                          <th>Действия</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredItems.map((data) => (
                          <tr key={data.id}>
                            <td>{data.product.vId} </td>
                            <td>{data.quantity}</td>
                            <td>{data.delivery_day} {data.delivery_day == 1 ? 'день' : data.delivery_day == 2 ? 'дня' : 'дней'}</td>
                            <td>
                              {type === "1" && (orderStatus === 0 || orderStatus === 7) ? (
                                <>
                                  <div>
                                    <select
                                      className="form-control"
                                      aria-label="Default select example"
                                      onChange={(e) =>
                                        this.handleWarehouseChange(e, data)
                                      }
                                      name="in_warehouse"
                                      value={data.warehouse_in || ""}
                                    >
                                      <option hidden>Выберите:</option>
                                      {warehouses.map((data) => (
                                        <option value={data.id} key={data.id}>
                                          {data.name_uz}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                </>
                              ) : (
                                <>{data.warehouse_name}</>
                              )}
                            </td>
                            <td>
                              {type === "1" && (orderStatus === 0 || orderStatus === 7) ? (
                                <>
                                  <div>
                                    <select
                                      className="form-control"
                                      aria-label="Default select example"
                                      onChange={(e) =>
                                        this.handleBarcodeChange(e, data)
                                      }
                                      name="barcode"
                                      value={data.barcode || ""}
                                    >
                                      <option>Zavod (1)</option>
                                      {data.product.units.map((data) => (
                                        <option
                                          value={data.barcode}
                                          key={data.id}
                                        >
                                          {data.barcode}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                </>
                              ) : (
                                <>{data.barcode}</>
                              )}
                            </td>
                            <td>
                              <button className="btn btn-danger">-</button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="order-list">
                    <label>Дополнительные товары</label>
                  </div>
                </div>
                <div className="purchase">
                  <div className="row">
                    <div className="col-4">
                      <h6>Способ оплаты</h6>
                      <select
                        className="form-control"
                        aria-label="Default select example"
                        onChange={this.handleChange}
                      >
                        <option defaultValue="1">Наличные</option>
                        <option value="2">Терминал</option>
                        {/* <option value="3">Click</option>
                        <option value="4">Payme</option> */}
                      </select>
                    </div>
                    <div className="col-4">
                      <h6>Статус платежа</h6>
                      <p style={{ color: "red" }}>{status}</p>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-4">
                      <h6>Сумма</h6>
                      <p>{price} руб</p>
                    </div>
                    <div className="col-4">
                      <h6>Скидка</h6>
                      <p>0 руб</p>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-4">
                      <h6>Предоплата</h6>
                      <p style={{ color: "red" }}>{this.state.status_payment} руб</p>
                    </div>
                    <div className="col-4">
                      <h6>Tizimga</h6>
                      <p>0 руб</p>
                    </div>
                    <div className="col-4">
                      <h6>Доставщику</h6>
                      <p>0 руб</p>
                    </div>
                  </div>
                </div>

                <div className="history">
                  <label>История заказов</label>
                  <table className="table">
                    <thead>
                      <tr>
                        <th>id</th>
                        <th>Статус</th>
                        <th>Manager</th>
                        <th>Дата</th>
                      </tr>
                    </thead>
                    <tbody>
                      {log.map((el) => (
                        <tr key={el.id}>
                          <td>{el.id}</td>
                          <td>{el.action}</td>
                          <td>{el.manager_name}</td>
                          <td>{el.date}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  {/* <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={(num) => this.handlePageChange(num)}
                  /> */}
                </div>
              </div>
            </div>
          </div>
        ) : (
          <Error status={resStatus} />
        )}
      </>
    );
  }
}
